import type { PersoneelsdienstenModel } from "@personeel/models/PersoneelsdienstenModel";
import type { PersoneelsdienstModel } from "@personeel/models/PersoneelsdienstModel";
import { DateTime, Interval } from "luxon";
import type { KlusModel } from "../../models/KlusModel";
import type { DienstOptie } from "./DienstOptie";

function getKlusInterval(k: KlusModel): Interval | null {
  if (!k.beginDatumtijd || !k.eindDatumtijd) return null;

  const start = k.beginDatumtijd;
  const end = k.eindDatumtijd;

  if (!start.isValid || !end.isValid) return null;

  return Interval.fromDateTimes(start, end);
}

/**
 * Bepaal wanneer de eerste klus begint en de laatst geselecteerde klus eindigt.
 */
export function berekenGezamenlijkInterval(klussen: KlusModel[]): Interval | null {
  const intervals = klussen.map(getKlusInterval).filter((i): i is Interval => i !== null);

  if (intervals.length === 0) return null;

  const earliestStart = intervals.reduce((min, i) => {
    const start = i.start!;
    return DateTime.min(start, min);
  }, intervals[0].start!);

  const latestEnd = intervals.reduce((max, i) => {
    const end = i.end!;
    return DateTime.max(end, max);
  }, intervals[0].end!);

  return Interval.fromDateTimes(earliestStart, latestEnd);
}

/**
 * Filter de personeelsdiensten: welke diensten dekken het gezamenlijke klus‑interval volledig?
 */
export function filterDienstenVoorKlussen(klussen: KlusModel[], pdds: PersoneelsdienstenModel[]) {
  const interval = berekenGezamenlijkInterval(klussen);
  if (!interval) return [];

  return pdds.flatMap((pdd) =>
    pdd.personeelsdiensten.filter((werkp) =>
      Interval.fromDateTimes(werkp.starttijd, werkp.eindtijd).engulfs(interval),
    ),
  );
}

export function mapWerkperiodeToDienstOptie(werkperiode: PersoneelsdienstModel): DienstOptie {
  return {
    id: werkperiode.id,
    value: werkperiode.id,
    label: werkperiode.label,
  };
}
